import { adt, iots, refinement, tagged } from '@code-expert/prelude';
import { CourseExaminee, EdozExaminee } from './Examinee';

export type EdozVerification = tagged.Tagged<'edoz', Array<EdozExaminee>>;

export const EdozVerification = iots.tagged('edoz', iots.array(EdozExaminee)) satisfies iots.Type<
  EdozVerification,
  unknown
>;

export const examVerificationModeKeys = {
  auto: null,
  manual: null,
};

export type ExamVerificationMode = keyof typeof examVerificationModeKeys;

export type CourseVerification = tagged.Tagged<
  'course',
  {
    mode: ExamVerificationMode;
    examinees: Array<CourseExaminee>;
  }
>;

export const foldVerificationMode = adt.foldFromKeys(examVerificationModeKeys);

export const CourseVerification = iots.tagged(
  'course',
  iots.strict({
    mode: iots.keyof(examVerificationModeKeys),
    examinees: iots.array(CourseExaminee),
  }),
) satisfies iots.Type<CourseVerification, unknown>;

export type ExamVerification = EdozVerification | CourseVerification;

export const ExamVerification = iots.union([
  EdozVerification,
  CourseVerification,
]) satisfies iots.Type<ExamVerification, unknown>;

export const examVerificationAdt = tagged.build<ExamVerification>();

export const examVerificationPrisms = tagged.prisms<ExamVerification>();

export const requireEdozVerification = refinement.invariant(
  examVerificationAdt.is.edoz,
  () => 'Requires verification method "edoz"',
);

export const requireCourseVerification = refinement.invariant(
  examVerificationAdt.is.course,
  () => 'Requires verification method "course"',
);

export const examVerificationTypeKeys = {
  edoz: null,
  course: null,
};

export const ExamVerificationTypeC = iots.keyof(examVerificationTypeKeys);

export const foldExamVerificationType = adt.foldFromKeys(examVerificationTypeKeys);

export type ExamVerificationType = adt.TypeOfKeys<typeof foldExamVerificationType>;

export const isAutoverifyExam = (x: ExamVerification) =>
  examVerificationAdt.is.course(x) && x.value.mode === 'auto';
